import { useContext } from "react";
import {
  ErrorDialogContext,
  errorHandledAsync,
  errorHandledSync,
} from "@/shared/context/error-context";
import { UpdateAccountGroupsService } from "@/features/accounts/account-group/services/update-account-groups-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useUpdateAccountGroupsStates } from "@/features/accounts/account-group/hooks/use-update-account-groups-states";
import { RegisteredAccount } from "@/features/accounts/account-group/services/update-account-groups-model";

interface Props {
  onTapCompleteModal: () => void;
}


export const useUpdateAccountGroups = ({ onTapCompleteModal }: Props) => {
  const {
    accountGroupName,
    setAccountGroupName,
    isActivateUpdateButton,
    setIsActivateUpdateButton,
  } = useUpdateAccountGroupsStates();

  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  // ローディング用コンテキスト
  const loadingCtx = useContext(LoadingModalContext);

  const updateAccountGroupsService = new UpdateAccountGroupsService();

  const onChangeGroupName = (value: string) => {
    setAccountGroupName(value);
  }

  const onChangeUpdateButtonState = (value: string) => {
    setIsActivateUpdateButton(value !== "");
  }

  /*--------------------
    イベント関連
  --------------------*/
  // 口座グループ更新
  const updateAccountGroups = async (
    accountGroupId: string,
    accountGroupName?: string,
    isSelected?: boolean,
    registeredAccounts?: RegisteredAccount[],
  ) => {
    loadingCtx.setIsLoading(true);
    try {
      await updateAccountGroupsService.updateAccountGroups({
        account_group_id: accountGroupId,
        ...(accountGroupName && { account_group_name: accountGroupName }),
        ...(isSelected && { is_selected: isSelected }),
        ...(registeredAccounts && { registered_accounts: registeredAccounts }),
      });

      onTapCompleteModal();
    } catch (error) {
      // エラーハンドリング
      console.log("updateAccountGroups:", error);
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    accountGroupName,
    setAccountGroupName,
    isActivateUpdateButton,
    setIsActivateUpdateButton,
    onChangeUpdateButtonState: errorHandledSync(onChangeUpdateButtonState, setError),
    onChangeGroupName: errorHandledSync(onChangeGroupName, setError),
    updateAccountGroups: errorHandledAsync(updateAccountGroups, setError),
  };
};
